import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ isAuthenticated, redirectPath = "/", children}) => {
    const location = useLocation();

    if(!isAuthenticated) {
        return <Navigate to={redirectPath} replace state={{ from: location }} />;
    }

    return children
}

export default ProtectedRoute;